export default "__VITE_PUBLIC_ASSET__c8a08ef5__"